import { Dialog } from '@strata/react-dialog';
import { SuccessToast } from '@strata/react-toast-message';
import PropTypes from 'prop-types';
import { useState } from 'react';

import { BulkChangeWarningMessage } from 'components/upcomingTreatments/dialogs/BulkChangeWarningMessage';
import { handleError } from 'services/Error';
import { useReprocessTreatmentMutation } from 'store/api/goLiveApi';

const Title = 'Release now';

export const ReprocessTreatmentDialog = ({
    isOpen,
    onClose,
    treatmentsCount = 0,
    apiQueryParams = undefined,
}) => {
    const [reprocessTreatment] = useReprocessTreatmentMutation();
    const [isSubmitting, setIsSubmitting] = useState(false);

    return (
        <Dialog
            dialogTitle={Title}
            isOpen={isOpen}
            width={560}
            secondaryButtonLabel="Cancel"
            onSecondaryButtonClick={() => {
                onClose();
            }}
            primaryButtonLabel={Title}
            isPrimaryButtonDisabled={isSubmitting}
            onPrimaryButtonClick={async () => {
                try {
                    setIsSubmitting(true);
                    await reprocessTreatment({ ...apiQueryParams }).unwrap();
                    SuccessToast({ message: 'Treatment released successfully.' });
                    onClose();
                } catch (err) {
                    handleError('Unable to release treatment. Please try again.', err);
                } finally {
                    setIsSubmitting(false);
                }
            }}
            dialogContent={
                <>
                    <div className="margin__bottom--medium">
                        This action will reprocess the active referral or evidence through routing,
                        while ensuring the treatment remains active.
                    </div>
                    <BulkChangeWarningMessage
                        apiQueryParams={apiQueryParams}
                        treatmentsCount={treatmentsCount}
                    />
                </>
            }
        />
    );
};

ReprocessTreatmentDialog.Title = Title;

ReprocessTreatmentDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    treatmentsCount: PropTypes.number,
    apiQueryParams: PropTypes.shape({
        treatmentId: PropTypes.string,
        searchText: PropTypes.string,
        goLiveDate: PropTypes.arrayOf(PropTypes.string),
        productServiceOid: PropTypes.arrayOf(PropTypes.string),
        segmentId: PropTypes.arrayOf(PropTypes.string),
        incumbentSupplier: PropTypes.arrayOf(PropTypes.string),
        productType: PropTypes.arrayOf(PropTypes.string),
        isLDD: PropTypes.arrayOf(PropTypes.bool),
        hasIssues: PropTypes.arrayOf(PropTypes.string),
        releaseStatus: PropTypes.arrayOf(PropTypes.string),
        upcomingTreatmentBatchName: PropTypes.arrayOf(PropTypes.string),
        preferredPharmacyOffer: PropTypes.arrayOf(PropTypes.string),
        therapeuticCategory: PropTypes.arrayOf(PropTypes.string),
    }),
};
